import { Component, render } from 'preact';
import { Slider } from '@rmwc/slider';
import { Select } from '@rmwc/select';
import { Checkbox } from '@rmwc/checkbox';
import { Grid, GridCell, GridRow } from '@rmwc/grid';
import { TextField } from '@rmwc/textfield';

import '@rmwc/select/styles';
import '@rmwc/slider/styles';
import '@rmwc/grid/styles';
import '@rmwc/checkbox/styles';
import '@rmwc/textfield/styles';

import Common from '/common.jsx';

import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';


export default class ConfigHeatmapSimple extends Common {
render(){

const { handle_input, input, styles, map_data } = this.props;

let map_options = ['Carto Dark', 'ArcGIS Sat'];

function parseDateISOString(s) {
    let ds = s.split(/\D/).map(s => parseInt(s));
    ds[1] = ds[1] - 1; // adjust month
    const d = new Date(...ds);
    //console.log(d);
    return d;
  }
  
const lerp_dates = (t) => {
    const date1 = parseDateISOString(input.gapi_date_start);
    const date2 = parseDateISOString(input.gapi_date_end);
    const date3 = new Date(date1.getTime() + t * (date2.getTime() - date1.getTime()));
    return date3;
}

const date_to_t = (date, time) => {
    const date1 = parseDateISOString(input.gapi_date_start);
    const date2 = parseDateISOString(input.gapi_date_end);
    const date3 = new Date(date);
    //console.log(date3);
    date3.setHours(time.split(':')[0], time.split(':')[1], time.split(':')[2]);
    const t = (date3.getTime() - date1.getTime()) / (date2.getTime() - date1.getTime());
    return t;
}

const lerp_dates_as_string = (t) => {
    //return in local time
    return lerp_dates(t).toString();
}

const date_to_yyyy_mm_dd = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year.toString().padStart(4, '0')}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
}

const date_to_24_hour_time_string = (date) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}


return(
<div {...styles.grid}>
<div {...styles.padded}>
{/*
< Grid >
< GridCell span={2} >
<TextField
    {...styles.textFieldSmall}
    outlined
    label="" type="date"
    value={input.hm_date_start}
    onChange={e => {
        handle_input({hm_time_range:[date_to_t(e.target.value, input.hm_time_start), input.hm_time_range[1]], hm_date_start:e.target.value})
        }}
/>
</GridCell>

< GridCell span={2} >
<TextField
    {...styles.textFieldSmall}
    outlined
    label="" type="time"
    value={input.hm_time_start}
    onChange={e => {
        handle_input({hm_time_range:[date_to_t(input.hm_date_start, e.target.value), input.hm_time_range[1]], hm_time_start:e.target.value})
        }}
/>
</GridCell>
to
< GridCell span={2} >
<TextField
    {...styles.textFieldSmall}
    outlined
    label="" type="date"
    value={input.hm_date_end}
    onChange={e => {
        handle_input({hm_time_range:[input.hm_time_range[0],date_to_t(e.target.value, input.hm_time_end)], hm_date_end:e.target.value})
        }}
/>
</GridCell>

< GridCell span={2} >
<TextField
    {...styles.textFieldSmall}
    outlined
    label="" type="time"
    value={input.hm_time_end}
    onChange={e => {
        handle_input({hm_time_range:[input.hm_time_range[0],date_to_t(input.hm_date_end, e.target.value)], hm_time_end:e.target.value})
        }}
/>
</GridCell>
</Grid>
*/}
    {`${lerp_dates_as_string(input.hm_time_range[0])} to ${lerp_dates_as_string(input.hm_time_range[1])}`}
    <RangeSlider 
            min={0} step={0.0001} value={input.hm_time_range} max={1}
            onInput={(e) => {
                handle_input({
                    hm_time_start:date_to_24_hour_time_string(lerp_dates(e[0])),
                    hm_time_end:date_to_24_hour_time_string(lerp_dates(e[1])),
                    hm_date_start:date_to_yyyy_mm_dd(lerp_dates(e[0])),
                    hm_date_end:date_to_yyyy_mm_dd(lerp_dates(e[1])),
                    hm_time_range:e,});
            }}
    /> 
    {`Subrange: ${input.hm_time} ${lerp_dates((input.hm_time_range[1]-input.hm_time_range[0])*input.hm_time + input.hm_time_range[0])}`}
    <Slider discrete={false} min={-0.1} value={input.hm_time} max={1}
        onInput={e => handle_input({hm_time:e.detail.value})}
    />  
    Subrange Padding: {input.hm_time_padding}
    <Slider discrete={false} min={-1} value={input.hm_time_padding} max={100}
        onInput={e => handle_input({hm_time_padding:e.detail.value})}
    />  
</div>
< Grid {...styles.grid}>
     
        < GridCell span={3} >       
            Heatmap Precision: {input.hm_prec}
            <Slider discrete={false} min={10} max={1000000} value={input.hm_prec}
                onInput={e => handle_input({hm_prec:e.detail.value})}
            />     
            Heatmap Scale: {input.hm_scale}
            <Slider discrete={false} min={1} value={input.hm_scale} max={100}
                onInput={e => handle_input({hm_scale:e.detail.value})}
            />              
       
        </ GridCell>
        < GridCell span={3} >       
            <Checkbox
            
            label="Auto Recenter"
            checked={input.map_recenter}
            onChange={e => handle_input({map_recenter:e.currentTarget.checked})}
            
            />     
        </ GridCell>
        < GridCell span={3} >       
            <Select 
                {...styles.select}
                hintText="Map Provider"
                defaultValue={'Carto Dark'}
                outlined
                box={true}
                
                onChange={e => handle_input({map_provider:map_options[e.currentTarget.index]})}
                value={input.map_provider}
                options={map_options}
            /> 
        </ GridCell>
    
</ Grid>
</div>
);

}
}